
module.exports = {
  // TODO: change your profile information here
  name: "Rohit S",
  greeting: "Hola 👋",
  greetingDescription: "I'm Rohit and I'm a Software Developer!",
  githubUrl: "https://github.com/itherohit",
  linkedinUrl: "https://www.linkedin.com/in/itherohit/",
  cvLink: "https://drive.google.com/file/d/1e1MaB2lAMGI9P7Wm1YPN_G9oM8AgNl4p/view?usp=sharing",
};
